import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './views/footer/footer.component';
import { HomeComponent } from './views/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderModule } from './views/header/header.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from './utility/app.init';
import { SidenavModule } from './views/sidenav/sidenav.module';
import { DataUploadModule } from './views/data-upload/data-upload.module';
import { DataUploadRoutingModule } from './views/data-upload/data-upload-routing.module';
import { DndDirective } from './directives/dnd.directive';
import { HttpClientModule } from '@angular/common/http';
import { SearchModule } from './views/search/search.module';
import { RequestService } from './services/requests.service';
import { SidenavService } from './services/sidenav.service';
import { AgGridModule } from 'ag-grid-angular';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { ManagementAnalyticsComponent } from './views/management-analytics/management-analytics.component';

@NgModule({
  declarations: [AppComponent, HomeComponent, DndDirective, FooterComponent, ManagementAnalyticsComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HeaderModule,
    FlexLayoutModule,
    KeycloakAngularModule,
    SidenavModule,
    DataUploadModule,
    DataUploadRoutingModule,
    SearchModule,
    AgGridModule,
    MatTabsModule,
    MatSelectModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    RequestService,
    SidenavService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
